import api from './AxiosInstance';
import printJS from "print-js";
import { api_URL } from "./Constantes";
export class ReportingExportService {

  /*  getAllParticipReport = async () => {
     try {
       const response = await api.get(`/Participant/List/AR`, {
    
       });
       return response.data;
     } catch (error) {
       console.error('Erreur lors de la récupération des données :', error);
       // Gérer l'erreur ici si nécessaire
       throw error; 
     }
   }; */

  getAllParticipReport = async (codeadht) => {
    try {
      const response = await api.get(`/Participant/List/${codeadht}`, {});
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllAdherentsReport = async () => {
    try {
      const response = await api.get(`/Adherent/ALL/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllFournisReport = async () => {
    try {
      const response = await api.get(`/Fournisseur/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllPrestaReport = async () => {
    try {
      const response = await api.get(`/Prestations/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getAllAdherReport = async () => {
    try {
      const response = await api.get(`/Adherent/1/list`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  exportAllReport = async (payload) => {

    try {
      const response = await api.post(`/Export/Reporting`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  printAllService = (codeExport, dateDeb, dateFin, codesoc = "all") => {
    const userId = localStorage.getItem('login');
    const username = localStorage.getItem('username');
    const url = `${api_URL}/Print/Reporting/${codeExport}?dateDeb=${dateDeb}&dateFin=${dateFin}&codesoc=${codesoc}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'user_id': userId,
        'username': username,
      },
    })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);

        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };



}


